export default {
    cptDataForm: {
        dataText: '{"value":60,"audioText":"自定义文本告警"}', dataSource: 1, pollTime: 0
    },
    attribute: {
        audioSrc: '/audio/Bottle.ogg',loop:true,alarmConfig:{operator:'>',threshold:null}
    },
    interaction:{intType: 'none'}
}
